app.service('ServiceQcm', function ($rootScope, services, fctService, $q) {
  var _DEBUG = 0;
  /*******************************************************************************************************/

  this.chargement = function (
    qcmSelectionne) {  // charge un qcm : uniquement page 0 (simple) et 1
    // (multiple)
    var deferred = $q.defer();

    try {
      // les données déjà présentes dans qcmSelectionne :
      //
      //"id":1240,"date":"2016-10-07T19:37:00.000Z","page":1,
      qcmSelectionne.id = qcmSelectionne.id;
      qcmSelectionne.date = qcmSelectionne.date;
      qcmSelectionne.page = qcmSelectionne.page;
      qcmSelectionne.remord = qcmSelectionne.remord;



      //"nbReponse":5,"UneSeuleReponse":1,
      qcmSelectionne.nbReponse = qcmSelectionne.nbReponse;  // entre 2 et 5

      // qcmSelectionne.UneSeuleReponse = qcmSelectionne.UneSeuleReponse % 2  //
      // 0 ou 1

      //"libelle":"","Matiere":"gte3",
      qcmSelectionne.libelle = qcmSelectionne.libelle;
      qcmSelectionne.Matiere = qcmSelectionne.Matiere;

      //"Nbcopies":0,

      //"ptJuste":1,"ptFaux":0,
      qcmSelectionne.ptJuste = qcmSelectionne.ptJuste;
      qcmSelectionne.ptFaux = qcmSelectionne.ptFaux;
      qcmSelectionne.ptVide = qcmSelectionne.ptVide;

      //"qcmSolution":"))))","nbQ":72,
      qcmSelectionne.qcmSolution = qcmSelectionne.qcmSolution;
      qcmSelectionne.nbQ = qcmSelectionne.nbQuestion;
      //"nbQuestion":4,"nbEtudiant":0,
      qcmSelectionne.nbQuestion =
        qcmSelectionne.nbQ;  // qcmSelectionne.nbQuestion, // 0 ou 1

      // bareme
      qcmSelectionne.QuneSeuleReponse =
        [];  // utile uniquement si pas "tout juste-tout faux"
      qcmSelectionne.modeCalcul = 0;
      if (qcmSelectionne.UneSeuleReponse >= 10) {  // 0 ou 1 ou 10
        for (var i = 0; i < qcmSelectionne.nbQ; i++) {
          var reponse = qcmSelectionne.qcmSolution[i];
          if (reponse == '(' || reponse == ')' || reponse == '*' ||
            reponse == ',' || reponse == '0' || reponse == '8')
            qcmSelectionne.QuneSeuleReponse[i] = 1;
          else
            qcmSelectionne.QuneSeuleReponse[i] = 0;
        }
        if (qcmSelectionne.UneSeuleReponse == 20)
          qcmSelectionne.QuneSeuleReponse[i] = 0;
        if (qcmSelectionne.UneSeuleReponse == 30)
          qcmSelectionne.QuneSeuleReponse[i] = 0;


        if (qcmSelectionne.UneSeuleReponse == 10)  // 0 ou 1 ou 10
          qcmSelectionne.modeCalcul = 1;
        if (qcmSelectionne.UneSeuleReponse == 20)  // 0 ou 1 ou 10
          qcmSelectionne.modeCalcul = 2;
        if (qcmSelectionne.UneSeuleReponse == 30)  // 0 ou 1 ou 10
          qcmSelectionne.modeCalcul = 3;
      }
      var bareme = [];
      // if (_DEBUG) console.info('Avant - services.bareme ('+qcmSelectionne.id
      // );
      services.bareme(qcmSelectionne.id).then(function (data) {
        // if (_DEBUG) console.info('pendant - services.bareme');
        qcmSelectionne.nbreponseJuste = [];
        qcmSelectionne.nbreponseVide = [];
        qcmSelectionne.ptSiJuste = [];
        qcmSelectionne.ptSiFaux = [];
        qcmSelectionne.ptSiVide = [];
        qcmSelectionne.ptSiBonus = [];

        for (var i = 0; i < qcmSelectionne.nbQ; i++) {
          qcmSelectionne.nbreponseJuste[i] = 0;
          qcmSelectionne.nbreponseVide[i] = 0;
          qcmSelectionne.ptSiJuste[i] = qcmSelectionne.ptJuste;
          qcmSelectionne.ptSiFaux[i] = qcmSelectionne.ptFaux;
          qcmSelectionne.ptSiVide[i] = qcmSelectionne.ptVide;
          if (qcmSelectionne.ptBonus == null)
            qcmSelectionne.ptSiBonus[i] = 0;
          else
            qcmSelectionne.ptSiBonus[i] = qcmSelectionne.ptBonus;
        }

        qcmSelectionne.nbBonus = 0;
        var baremeMODIF = data.data;
        if (baremeMODIF.length > 0)
          // alert("b : "+bareme[0].question+" et nombre
          // d'itération="+bareme.length)

          for (i = 0; i < baremeMODIF.length; i++) {
            // alert("i="+i)
            question = baremeMODIF[i].question -
              1;  // bon numéro de question dans la table bareme !!
            qcmSelectionne.ptSiJuste[question] = baremeMODIF[i].juste;
            qcmSelectionne.ptSiFaux[question] = baremeMODIF[i].faux;
            qcmSelectionne.ptSiVide[question] = baremeMODIF[i].vide;
            qcmSelectionne.ptSiBonus[question] = baremeMODIF[i].bonus;
            if (baremeMODIF[i].bonus == 1) qcmSelectionne.nbBonus++;
          }
        /*     })
             .catch(function(response){
                 if (_DEBUG) console.info('message='+response.data.message+' et
           ='+ response.status); throw(response);
             })
       */
        if (_DEBUG) console.info('apres - services.bareme');
        // qcmSelectionne.ptSiJuste={"1":10,"2":10,"3":10,"4":8,"5":5,"6":5,"7":4,"8":5,"9":10,"10":10,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}
        // qcmSelectionne.ptSiFaux={"1":10,"2":10,"3":10,"4":8,"5":5,"6":5,"7":4,"8":5,"9":10,"10":10,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}
        // qcmSelectionne.ptSiVide={"1":10,"2":10,"3":10,"4":8,"5":5,"6":5,"7":4,"8":5,"9":10,"10":10,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}


        //"nbpage":10,    // entre 1 (simple)  et 16 (multi)
        // nombrePageTab
        // = {"1":10,"2":10,"3":10,"4":8,"5":5,"6":5,"7":4,"8":5,"9":10,"10":10,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}
        // qcmSelectionne.nombrePageTab
        // = {"1":10,"2":10,"3":10,"4":8,"5":5,"6":5,"7":4,"8":5,"9":10,"10":10,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0}

        qcmSelectionne.multi_nbpage =
          qcmSelectionne.multi_nbpage;  // 0:ancien,  =1:multipage
        qcmSelectionne.PremiereQuestionPageTab = [];
        qcmSelectionne.PremiereQuestionPageTab[0] = 0;

        if (qcmSelectionne.multi_nbpage >= 1) {
          // alert("multi")
          services.nombrePageTab(qcmSelectionne.id).then(function (data) {
            var j;
            if (_DEBUG) console.info('lg=' + data.data.length);
            for (i = 0; i < data.data.length; i++) {
              qcmSelectionne.PremiereQuestionPageTab[i + 1] =
                data.data[i].nbq + qcmSelectionne.PremiereQuestionPageTab[i];
              j = i;
              if (_DEBUG)
                console.info(
                  'PremiereQuestionPageTab=' +
                  qcmSelectionne.PremiereQuestionPageTab[i + 1]);
            }
            qcmSelectionne.PremiereQuestionPageTab[j + 1] = qcmSelectionne.nbQ;
            qcmSelectionne.multi_nbpage = data.data.length;
          });
        } else {
          qcmSelectionne.PremiereQuestionPageTab[1] = qcmSelectionne.nbQ;
        }

        // charger les étudiants

        // listeEtudiant =[
        //{"idetudiant":45697,"nom":"zerouali","prenom":"reda","numero":1671,"idqcm":1240,"idetudiantDuplicate":null},
        //{"idetudiant":45696,"nom":"viret--denaix","prenom":"tugdual","numero":1670,"idqcm":1240,"idetudiantDuplicate":null}
        //... ]
        services.listeEtudiant(qcmSelectionne.id).then(function (data) {
          qcmSelectionne.listeEtudiant = data.data;
          qcmSelectionne.nbEtudiant = qcmSelectionne.listeEtudiant.length

          // listeCopie=[
          //{"idetudiant":45690,"page":8,"fichier":"1664--20160905092657.pdf","fichierUpload":"1664--20160905092657.pdf",
          //"note":0,"doute":0,"resultat":"(((((","id":63945,"numEtudiant":1664,"nom":"seillier","prenom":"quentin"},
          //{"idetudiant":45696,"page":3,"fichier":"1664--20160905092657.pdf","fichierUpload":"1664--20160905092657.pdf",
          //"note":0,"doute":0,"resultat":"(((((","id":63944,"numEtudiant":1670,"nom":"viret--denaix","prenom":"tugdual"}
          //...]
          idq = qcmSelectionne.id;
          // console.log(JSON.stringify(qcmSelectionne));
          if (qcmSelectionne.remord) {
            services.majRemord(idq).then(function () {
              if (_DEBUG) console.log('remord!!!!!!!!!!');

              services.listeCopie(idq).then(function (data) {
                // alert("copie")
                qcmSelectionne.listeCopie = data.data;

                initListeEtudiant(qcmSelectionne);
                // calculNotes(qcmSelectionne)
                // return qcmSelectionne
                deferred.resolve(qcmSelectionne);
              });  // listeCopie
            });
          } else {
            services.listeCopie(idq).then(function (data) {
              // alert("copie")
              qcmSelectionne.listeCopie = data.data;

              initListeEtudiant(qcmSelectionne);
              // calculNotes(qcmSelectionne)
              // return qcmSelectionne
              deferred.resolve(qcmSelectionne);
            });  // listeCopie
          }      // majRemord
        });      // listeEtudiant
      });        // bareme

    } catch (e) {
      if (_DEBUG)
        console.info(
          'message=' + response.data.message + ' et =' + response.status);

      deferred.reject(e);
    }  // try-catch
    return deferred.promise
  };  // fin de this.initialise


  /*******************************************************************************************************/ /*******************************************************************************************************/
/*
  this.remordUpdateCopie = function (
    qcmSelectionne) {
    var deferred = $q.defer();
console.log('debut qcm2.js');
    try {
      services.remordUpdateCopie(qcmSelectionne.id).then(function (data) {
        a = data;
        initListeEtudiant(qcmSelectionne);
        calculNotes(qcmSelectionne)
        // return qcmSelectionne
        deferred.resolve(a);
      });  // listeCopie

    } catch (e) {
      if (_DEBUG)
        console.info(
          'message=' + response.data.message + ' et =' + response.status);

      deferred.reject(e);
    }  // try-catch
    console.log('fin qcm2.js');
    return deferred.promise
  };  // fin de this.initialise
*/  
  /*******************************************************************************************************/ /*******************************************************************************************************/
/*
  this.remordUpdateCopie2 = async function (
    qcmSelectionne, copie) {
      console.log('debut qcm2v2.js');
      await new services.remordUpdateCopie(qcmSelectionne.id, copie);
      console.log('fin qcm2v2.js');
    };  // fin de this.initialise
*/    
  /*******************************************************************************************************/
  var initListeEtudiant =
    function (qcmSelectionne) {  // Etudiant.tabCopie et Etudiant.resultat
      var deferred = $q.defer();

      try {
        // qcmSelectionne.PremiereQuestionPageTab[j+1]


        var tabIndiceCopie = [];
        var tabReponse = [];

        var length = qcmSelectionne.page + 1;  // user defined length
        var str = '('

        if (qcmSelectionne.multi_nbpage == 0) {  // simple cas
          tabIndiceCopie.push(-1);
          var nb = qcmSelectionne.PremiereQuestionPageTab[1] -
            qcmSelectionne.PremiereQuestionPageTab[0];
          var str2 = str.repeat(nb);
          tabReponse.push(str2);
        }
        else {  // multi page
          tabReponse.push('');
          for (var i = 0; i < length; i++) {
            tabIndiceCopie.push(-1);
            nb = qcmSelectionne.PremiereQuestionPageTab[i + 1] -
              qcmSelectionne.PremiereQuestionPageTab[i];
            str2 = str.repeat(nb);
            tabReponse.push(str2);
          }
        }

        if (_DEBUG) console.info('1B');
        str = '(';
        str2 = str.repeat(qcmSelectionne.nbQ);

        var TABlisteEtudiant = new Array();
        var TABlisteNumeroEtudiant = new Array();
        for (i = 0; i < qcmSelectionne.nbEtudiant; i++) {
          var indice = qcmSelectionne.listeEtudiant[i].idetudiant;
          TABlisteEtudiant[indice] = i;
          var numero = qcmSelectionne.listeEtudiant[i].numero;
          // qcmSelectionne.listeEtudiant[i].numero=Number(qcmSelectionne.listeEtudiant[i].numero);
          TABlisteNumeroEtudiant[numero] = i;

          qcmSelectionne.listeEtudiant[i].nbcopie = 0;  // pas de copie associée
          qcmSelectionne.listeEtudiant[i].reponse = str2;
          qcmSelectionne.listeEtudiant[i].moyenne =
            -100;  // pas de copie associée
          qcmSelectionne.listeEtudiant[i].sommenote =
            -100;  // pas de copie associée

          qcmSelectionne.listeEtudiant[i].tabReponse =
            angular.copy(tabReponse);  // pas de copie associée
          qcmSelectionne.listeEtudiant[i].tabIndiceCopie =
            angular.copy(tabIndiceCopie);  // pas de copie associée
          qcmSelectionne.listeEtudiant[i].lib =
            qcmSelectionne.listeEtudiant[i].numero + ' ' +
            qcmSelectionne.listeEtudiant[i].nom + ' ' +
            qcmSelectionne.listeEtudiant[i].prenom;
        }
        if (_DEBUG) console.info('1C');
        // parcourir les copie pour les ajouter au TABlisteEtudiant
        // if (qcmSelectionne.multi_nbpage>0){ // multi : uniquement les étudiants
        var nbCopie = qcmSelectionne.listeCopie.length
        if (_DEBUG) console.info('############# nbCopie=' + nbCopie);

        for (var k = 0; k < nbCopie; k++) {
          var page = qcmSelectionne.listeCopie[k].page;
          /// if (_DEBUG) console.info('-----page='+page)
          var indice = qcmSelectionne.listeCopie[k].idetudiant;
          var numero = qcmSelectionne.listeCopie[k].numEtudiant;

          // if (_DEBUG) console.info('indice='+indice+' et
          // '+qcmSelectionne.listeCopie[k].id)

          if (indice != null &&
            indice != 0) {  // l'indice est connu : pas de problème
            if (typeof (TABlisteEtudiant[indice]) == 'undefined') {
              ;
              // vérification : là, il y a un problème !!!
            } else {
              /// if (_DEBUG) console.info('indice connu ='+indice)
              var i_etud = TABlisteEtudiant[indice];
              /// if (_DEBUG) console.info('i_etud='+i_etud)
              qcmSelectionne.listeEtudiant[i_etud].tabIndiceCopie[page] = k;
              qcmSelectionne.listeEtudiant[i_etud].nbcopie =
                1 + qcmSelectionne.listeEtudiant[i_etud].nbcopie;
              // if (_DEBUG) console.info('qcmSelectionne.listeCopie[k].resultat
              // ='+qcmSelectionne.listeCopie[k].resultat)



              if (qcmSelectionne.multi_nbpage > 1) {
                nb = qcmSelectionne.PremiereQuestionPageTab[page] -
                  qcmSelectionne.PremiereQuestionPageTab[page - 1];
                resultat = qcmSelectionne.listeCopie[k].resultat;
                qcmSelectionne.listeEtudiant[i_etud].tabReponse[page] =
                  resultat.substring(0, nb);
              } else {
                qcmSelectionne.listeEtudiant[i_etud].tabReponse[page] =
                  qcmSelectionne.listeCopie[k].resultat;
              }
            }

          } else {  // pas d'indice, trouver par le numéro d'étudiant !!
            /// if (_DEBUG) console.info('indice null avec k = '+k)
            if (numero != null &&
              numero != 0) {  // l'indice est connu : pas de problème
              if (typeof (TABlisteNumeroEtudiant[numero]) == 'undefined') {
                // vérification : là, il y a un problème !!!
                qcmSelectionne.listeCopie[k].doute = 10;
              } else {
                /// if (_DEBUG) console.info("étudiant connu par NUMERO :"+numero)
                var i_etud = TABlisteNumeroEtudiant[numero];
                /// if (_DEBUG) console.info('trouvé : i_etud='+i_etud)
                qcmSelectionne.listeEtudiant[i_etud].tabIndiceCopie[page] = k;
                qcmSelectionne.listeEtudiant[i_etud].nbcopie =
                  1 + qcmSelectionne.listeEtudiant[i_etud].nbcopie;
                // if (_DEBUG) console.info('qcmSelectionne.listeCopie[k].resultat
                // ='+qcmSelectionne.listeCopie[k].resultat)
                qcmSelectionne.listeEtudiant[i_etud].tabReponse[page] =
                  qcmSelectionne.listeCopie[k].resultat;
                qcmSelectionne.listeCopie[k].idetudiant =
                  qcmSelectionne.listeEtudiant[i_etud].idetudiant;
                qcmSelectionne.listeCopie[k].nom =
                  qcmSelectionne.listeEtudiant[i_etud].nom;
                qcmSelectionne.listeCopie[k].prenom =
                  qcmSelectionne.listeEtudiant[i_etud].prenom;
              }
            }
          }

        }  // for
        //}

        if (_DEBUG) console.info('4:');
        calculNotesTOUTES(qcmSelectionne);
        majProbleme(qcmSelectionne);

      } catch (e) {
        deferred.reject(e);
      }  // try-catch
      return deferred.promise;
    }  // fin de this.initialiseEtudiant

  /*******************************************************************************************************/

  // on change une case de la solution !
  this.initListeEtudiant = function (
    qcmSelectionne) {  // calcule de sommenote et moyenne -> par copie et
    // au global !
    if (_DEBUG) console.info('initListeEtudiant');
    return initListeEtudiant(qcmSelectionne);
  };  // fin de this.initListeEtudiant

  /*******************************************************************************************************/

  var majProbleme =
    function (qcmSelectionne) {  // Etudiant.tabCopie et Etudiant.resultat
      var deferred2 = $q.defer();

      try {
        qcmSelectionne.ListeEtudiantLibre =
          new Array;  // calculer tous les étudiants sans copie
        qcmSelectionne.ListeCopieDoublon =
          new Array;  // calculer tous les étudiants sans copie

        qcmSelectionne.ListeCopieDoute =
          new Array;  // calculer tous les étudiants sans copie
        qcmSelectionne.ListeCopieInconnues =
          new Array;  // calculer tous les étudiants sans copie
        qcmSelectionne.ListeEtudiantNull =
          new Array;  // calculer tous les étudiants sans copie
        qcmSelectionne.ListePBpage =
          new Array;  // calculer tous les étudiants sans copie //new


        var nbEtudiant = 0;
        if (qcmSelectionne.listeEtudiant == null)
          nbEtudiant = 0;
        else
          nbEtudiant = qcmSelectionne.listeEtudiant.length;


        var nbCopie = 0;
        if (qcmSelectionne.listeEtudiant == null)
          nbCopie = 0;
        else
          nbCopie = qcmSelectionne.listeCopie.length;

        /***************************************************/
        // liste des étudiants sans copies, ou pour lequel il manque une copie
        // (cas multi) : ListeEtudiantLibre
        for (var i = 0; i < nbEtudiant; i++) {
          var trouve = false;
          if (qcmSelectionne.multi_nbpage == 0) {  // simple
            if (qcmSelectionne.listeEtudiant[i].tabIndiceCopie[0] >= 0) {
              trouve = true;
              // if (_DEBUG) console.info("(+)")
            } else {
              ;
              // if (_DEBUG) console.info("(-)")
            }
          } else {  // multi
            trouve = true;
            for (var j = 1; j <= qcmSelectionne.multi_nbpage; j++) {
              if (qcmSelectionne.listeEtudiant[i].tabIndiceCopie[j] == -1) {
                trouve = false;
                j = 30;
              }
            }
          }

          if (!trouve) {
            qcmSelectionne.ListeEtudiantLibre.push(
              $rootScope.qcmSelectionne.listeEtudiant[i]);
          }
        }


        /***************************************************/
        // liste des copies des doublons/inconnues/doute - cas SIMPLE
        if (qcmSelectionne.multi_nbpage == 0) {
          for (var i = 0; i < nbCopie; i++) {
            // alert('idetudiant(i)'+i+'-->'+$rootScope.listeCopie[i].idetudiant)

            if (qcmSelectionne.listeCopie[i].idetudiant == null ||
              qcmSelectionne.listeCopie[i].idetudiant == 0) {
              qcmSelectionne.ListeCopieInconnues.push(
                qcmSelectionne.listeCopie[i]);
              qcmSelectionne.listeCopie[i].doute = 1;

            } else if (qcmSelectionne.listeCopie[i].idetudiant > 0) {
              for (var j = 0; j < i; j++) {
                // alert('idetudiant(j)'+j+'-->'+$rootScope.listeCopie[j].idetudiant)
                if (qcmSelectionne.listeCopie[i].idetudiant ==
                  qcmSelectionne.listeCopie[j].idetudiant) {
                  qcmSelectionne.ListeCopieDoublon.push(
                    qcmSelectionne.listeCopie[i]);
                  qcmSelectionne.ListeCopieDoublon.push(
                    qcmSelectionne.listeCopie[j]);
                  qcmSelectionne.listeCopie[i].doute = 3;
                  qcmSelectionne.listeCopie[j].doute = 3;
                }
              }
            }
            // liste des copies avec "doute"
            if (qcmSelectionne.listeCopie[i].doute != 0) {
              qcmSelectionne.ListeCopieDoute.push(qcmSelectionne.listeCopie[i]);
            }
          }
        } else {  // multi page
          // liste des copies des doublons/inconnues/doute - cas MULTI
          for (var i = 0; i < nbCopie; i++) {
            // alert('idetudiant(i)'+i+'-->'+$rootScope.listeCopie[i].idetudiant)

            // new
            if (qcmSelectionne.listeCopie[i].page > qcmSelectionne.multi_nbpage ||
              qcmSelectionne.listeCopie[i].page < 1) {
              qcmSelectionne.ListePBpage.push(qcmSelectionne.listeCopie[i]);
              qcmSelectionne.listeCopie[i].doute = 10;
            }

            if (qcmSelectionne.listeCopie[i].idetudiant == null ||
              qcmSelectionne.listeCopie[i].idetudiant == 0) {
              qcmSelectionne.ListeCopieInconnues.push(
                qcmSelectionne.listeCopie[i]);
              qcmSelectionne.ListeEtudiantNull.push(qcmSelectionne.listeCopie[i]);
              qcmSelectionne.listeCopie[i].doute = 1;

            } else if (qcmSelectionne.listeCopie[i].idetudiant != 0) {
              for (var j = 0; j < i; j++) {
                // alert('idetudiant(j)'+j+'-->'+$rootScope.listeCopie[j].idetudiant)
                if (qcmSelectionne.listeCopie[i].idetudiant ==
                  qcmSelectionne.listeCopie[j].idetudiant &&
                  qcmSelectionne.listeCopie[i].page ==
                  qcmSelectionne.listeCopie[j].page) {
                  qcmSelectionne.ListeCopieDoublon.push(
                    qcmSelectionne.listeCopie[i]);
                  qcmSelectionne.ListeCopieDoublon.push(
                    qcmSelectionne.listeCopie[j]);
                  qcmSelectionne.listeCopie[i].doute = 5;
                  qcmSelectionne.listeCopie[j].doute = 5;

                  qcmSelectionne.ListePBpage.push(qcmSelectionne.listeCopie[i]);
                  qcmSelectionne.ListePBpage.push(qcmSelectionne.listeCopie[j]);
                }
              }
            } else if (
              qcmSelectionne.listeCopie[j].idetudiant == null ||
              qcmSelectionne.listeCopie[j].idetudiant == 0) {
              // liste des copies sans étudiants
              qcmSelectionne.ListeCopieInconnues.push(
                $rootScope.qcmSelectionne.listeCopie[i]);
              qcmSelectionne.listeCopie[i].doute = 1;
            }
            // liste des copies avec "doute"
            if (qcmSelectionne.listeCopie[i].doute != 0) {
              qcmSelectionne.ListeCopieDoute.push(qcmSelectionne.listeCopie[i]);
            }
          }
        }



      } catch (e) {
        deferred2.reject(e);
      }  // try-catch
      return deferred2.promise;
    }  // fin de this.majProbleme

  /*******************************************************************************************************/
  // solution et reponse = un caractère chacun,
  // modeCalcul=0 (Toutjuste/toutFaux) - =1 (partiel)
  var calculPointQuestion = function (
    indice, solution, reponse, qcmSelectionne) {
    // if (qcmSelectionne.modeCalcul == 0 ||
    // qcmSelectionne.QuneSeuleReponse[indice]) {//tout juste - tout faux
    if (qcmSelectionne.modeCalcul == 0) {  // tout juste - tout faux
      if (reponse == '(' || solution == '(') {
        qcmSelectionne.nbreponseVide[indice]++;
        // if (_DEBUG) console.info('('+indice+')-'+'vide -
        // pt='+qcmSelectionne.ptSiVide[indice]);

        return qcmSelectionne.ptSiVide[indice];
      } else if (reponse == solution) {
        qcmSelectionne.nbreponseJuste[indice]++;
        // if (_DEBUG) console.info('('+indice+')-'+'juste -
        // pt='+qcmSelectionne.ptSiJuste[indice]);

        return qcmSelectionne.ptSiJuste[indice];
      } else {
        // if (_DEBUG) console.info('('+indice+')-'+'faux -
        // pt='+qcmSelectionne.ptSiFaux[indice]);

        return qcmSelectionne.ptSiFaux[indice];
      }
      // mode de calcul différent ! - pour cette question, il y a plusieurs
      // réponses !
    } else if (qcmSelectionne.modeCalcul == 2) {
      // medecine : chaque case a la même valeur dans la question (cochée ou pas
      // cochée)
      /* if (reponse == '(') {  // pour obliger les étudiants à remplir !
         // if (_DEBUG) console.info('('+indice+')-'+'vide reponse');
         return qcmSelectionne.ptSiVide[indice];  // pas possible !
       }*/
      var rep = reponse.charCodeAt(0) - 40;  //"ABC".charCodeAt(0) // returns 65
      var sol = solution.charCodeAt(0) - 40;

      var NbRdansSolution = 0;
      var NbJdansReponse = 0;
      var NbFdansReponse = 0;

      for (var b = 1; b < 17; b = b * 2) {
        if ((sol & b) == (rep & b))
          NbJdansReponse++;
        else
          NbFdansReponse++;
      }
      if (NbRdansSolution == 0) {
        // if (_DEBUG) console.info('____________________faux0 -
        // NbRdansSolution='+NbRdansSolution+'  et solution'+solution);
      }

      var pt = NbJdansReponse * qcmSelectionne.ptSiJuste[indice] /
        qcmSelectionne.nbReponse;
      return pt;


    } else if (qcmSelectionne.modeCalcul == 3) {
      // medecine : diploma...
      if (reponse == '(') {  // pour obliger les étudiants à remplir !
        if (_DEBUG)
          console.info(
            '(' + indice + ')-' +
            'vide reponse');
        return qcmSelectionne.ptSiVide[indice];  // pas possible !
        // Une réponse fausse = Ne pas cocher une bonne réponse OU Cocher une
        // mauvaise réponse
      }
      if (_DEBUG) console.info('diploma');
      var rep = reponse.charCodeAt(0) - 40;  //"ABC".charCodeAt(0) // returns 65
      var sol = solution.charCodeAt(0) - 40;

      var NbRfausse = 0;
      var NbRjuste = 0;
      var NbRdansSolution = 0;

      var pt = 0;

      for (var b = 1; b < 17; b = b * 2) {
        if ((sol & b) > 0) NbRdansSolution++;

        if (sol & b) {  // case à cocher
          if (rep & b)
            NbRjuste++;
          else
            NbRfausse++;
        } else {  // case à na pas cocher
          if (rep & b)
            NbRfausse++;
          else
            NbRjuste++;
        }
      }
      if (NbRdansSolution == 1) {
        if (NbRfausse >= 1)
          pt = 0;
        else
          pt = qcmSelectionne.ptSiJuste[indice];
      }

      if (NbRdansSolution > 1) {
        if (NbRfausse == 0)
          pt = qcmSelectionne.ptSiJuste[indice];
        else if (NbRfausse == 1)
          pt = qcmSelectionne.ptSiJuste[indice] / 2;
        else if (NbRfausse == 2)
          pt = qcmSelectionne.ptSiFaux[indice];
        else
          pt = qcmSelectionne.ptSiVide[indice];
      }
      if (_DEBUG) console.info('__________indice=' + indice);
      if (_DEBUG) console.info('__________NbRjuste=' + NbRjuste);
      if (_DEBUG) console.info('__________NbRfausse=' + NbRfausse);
      if (_DEBUG) console.info('__________NbRdansSolution=' + NbRdansSolution);
      if (_DEBUG) console.info('__________pt=' + pt);

      if (_DEBUG) console.info('pt=', pt);
      return pt;


    } else if (qcmSelectionne.modeCalcul == 1) {
      if (reponse == '(') {
        // if (_DEBUG) console.info('('+indice+')-'+'vide reponse');
        return qcmSelectionne.ptSiVide[indice];  // pas possible !
      }
      if (solution == '(') {
        // if (_DEBUG) console.info('('+indice+')-'+'vide solution');
        return qcmSelectionne.ptSiVide[indice];  // pas possible !
      }

      var rep = reponse.charCodeAt(0) - 40;  //"ABC".charCodeAt(0) // returns 65
      var sol = solution.charCodeAt(0) - 40;

      var NbRdansSolution = 0;
      var NbJdansReponse = 0;
      var NbFdansReponse = 0;

      for (var b = 1; b < 17; b = b * 2) {
        if ((sol & b) > 0) NbRdansSolution++;
        if ((rep & b) > 0) {
          if ((sol & b) > 0)
            NbJdansReponse++;
          else
            NbFdansReponse++;
        }
      }
      if (NbRdansSolution == 0) {
        // if (_DEBUG) console.info('____________________faux0 -
        // NbRdansSolution='+NbRdansSolution+'  et solution'+solution);
      }

      var pt = (NbJdansReponse - NbFdansReponse) *
        qcmSelectionne.ptSiJuste[indice] / NbRdansSolution;
      if (pt <= qcmSelectionne.ptSiFaux[indice]) {
        // if (_DEBUG) console.info('('+indice+')-'+'faux2 -
        // pt='+qcmSelectionne.ptSiFaux[indice]);
        return qcmSelectionne.ptSiFaux[indice];
      } else {
        // if (_DEBUG) console.info('('+indice+')-'+'faux1 - pt='+pt);
        return pt;
      }
    }  // mode de calcul différent !
  };


  /*******************************************************************************************************/
  // on change une case de la solution !
  this.calculNotesTOUTES = function (
    qcmSelectionne) {  // calcule de sommenote et moyenne -> par
    // copie et au global !
    if (_DEBUG) console.info('calculNotesTOUTES');
    return calculNotesTOUTES(qcmSelectionne);
  };  // fin de this.initListeEtudiant


  /*******************************************************************************************************/
  var calculNotesTOUTES = function (
    qcmSelectionne) {  // calcule de sommenote et moyenne -> par
    // copie et au global !
    var deferred3 = $q.defer();
    try {
      // alert("calculNotes")
      if (_DEBUG) console.info('calculNotesTOUTES');

      // ***moyenne, sommenotes***
      qcmSelectionne.moyenne = 0;
      qcmSelectionne.sommenote = 0;
      qcmSelectionne.justeTotal = 0;
      qcmSelectionne.sommeTotal = 0;

      var Total = 0.0, sommeE = 0;
      for (var j = 0; j < qcmSelectionne.nbQ; j++) {
        if (!qcmSelectionne.ptSiBonus[j]) Total += qcmSelectionne.ptSiJuste[j];
      }
      qcmSelectionne.justeTotal = Total;
      if (Total == 0) {
        alert('erreur : somme des points égale 0');
        return;
      }
      if (_DEBUG) console.info('Total' + Total);


      //******************************
      if (qcmSelectionne.multi_nbpage > 0 &&
        qcmSelectionne.listeEtudiant.length == 0) {
        if (_DEBUG)
          console.info('calculNotes - moyenne = Pas d\'ETUDIANT\' !!');
      } else if (
        qcmSelectionne.multi_nbpage == 0 &&
        qcmSelectionne.listeCopie.length == 0) {
        if (_DEBUG) console.info('calculNotes - moyenne = Pas de copie !!');
      } else {  // if (qcmSelectionne.multi_nbpage>0){ // multi : uniquement les
        // étudiants


        qcmSelectionne.nbTotal = 0;
        var reponse;

        for (var i = 0; i < qcmSelectionne.listeEtudiant.length; i++) {  // new
          // if (_DEBUG) console.info('etudiant :'+i)
          reponse = '';
          /**** recalcul de reponse ***/
          if (qcmSelectionne.multi_nbpage > 0) {
            var length = qcmSelectionne.multi_nbpage;  // user defined length
            for (var k = 0; k < length; k++) {
              nb = qcmSelectionne.PremiereQuestionPageTab[k + 1] -
                qcmSelectionne.PremiereQuestionPageTab[k];
              // if (qcmSelectionne.listeEtudiant[i].numero==100) if (_DEBUG)
              // console.info('qcmSelectionne.PremiereQuestionPageTab[k+1]='+qcmSelectionne.PremiereQuestionPageTab[k+1])
              // if (qcmSelectionne.listeEtudiant[i].numero==100) if (_DEBUG)
              // console.info('nb='+nb)
              rep = qcmSelectionne.listeEtudiant[i].tabReponse[k + 1];
              reponse = reponse + rep.substring(0, nb);
              // if (qcmSelectionne.listeEtudiant[i].numero==100) if (_DEBUG)
              // console.info('reponse='+reponse)
            }
            qcmSelectionne.listeEtudiant[i].reponse = reponse;
          } else {
            reponse = qcmSelectionne.listeEtudiant[i].tabReponse[0];
            qcmSelectionne.listeEtudiant[i].reponse =
              qcmSelectionne.listeEtudiant[i].tabReponse[0];
          }
          // if (qcmSelectionne.listeEtudiant[i].numero==100) if (_DEBUG)
          // console.info('reponse100 :'+reponse)

          /***************************/

          // if (_DEBUG)
          // console.info('numero='+qcmSelectionne.listeEtudiant[i].numero+'
          // resultat='+qcmSelectionne.listeEtudiant[i].resultat)
          var sommeE = 0.0;

          if (qcmSelectionne.listeEtudiant[i].nbcopie >=
            1) {  // si l'étudiant a une copie : on  note chaque question :
            for (var j = 0; j < qcmSelectionne.nbQ; j++) {
              sommeE = sommeE +
                calculPointQuestion(
                  j, qcmSelectionne.qcmSolution[j], reponse[j],
                  qcmSelectionne);
              // if (_DEBUG) console.info('sommeE :('+j+') ='+sommeE)
            }
            // if (_DEBUG) console.info('sommeE :('+j+') ='+sommeE)
            qcmSelectionne.listeEtudiant[i].sommenote = sommeE;
            qcmSelectionne.listeEtudiant[i].moyenne =
              1.0 * sommeE / Total * 20.0;

            // if (_DEBUG)
            // console.info('res='+qcmSelectionne.listeEtudiant[i].reponse +' et
            // moyenne='+qcmSelectionne.listeEtudiant[i].sommepoints)
            qcmSelectionne.nbTotal++;
            qcmSelectionne.sommeTotal += sommeE;


            for (var ind = 0;
              ind < qcmSelectionne.listeEtudiant[i].tabIndiceCopie.length;
              ind++) {
              var indiceC = qcmSelectionne.listeEtudiant[i].tabIndiceCopie[ind];
              if (indiceC >= 0)
                qcmSelectionne.listeCopie[indiceC].sommepoints =
                  qcmSelectionne.listeEtudiant[i].sommenote;
            }
          }
        }
      }
      if (qcmSelectionne.nbTotal > 0 && qcmSelectionne.justeTotal > 0) {
        var res = qcmSelectionne.sommeTotal / qcmSelectionne.nbTotal * 20 /
          qcmSelectionne.justeTotal;
        if (_DEBUG) console.info('calculNotes - moyenne générale = ' + res);
      }
      // return qcmSelectionne
      deferred3.resolve(qcmSelectionne);

    } catch (e) {
      deferred3.reject(e);
    }  // try-catch
    return deferred3.promise;

  };  // fin de this.calculNotes
  /*******************************************************************************************************/
  // on change une case de la solution !
  this.calculNotes = function (
    qcmSelectionne) {  // calcule de sommenote et moyenne -> par
    // copie et au global !
    return calculNotesTOUTES(qcmSelectionne);
  };  // fin de this.calculNotes

  /*******************************************************************************************************/
  // on change une case de la solution !
  this.calculNotesModifSolution = function (
    qcmSelectionne, c, cAvant,
    caseM) {  // calcule de sommenote et moyenne -> par copie et
    // au global !
    var deferred = $q.defer();
    // alert("c="+c+", cAvant="+cAvant+", caseM="+caseM)
    try {
      if (qcmSelectionne.multi_nbpage > 0 &&
        qcmSelectionne.listeEtudiant.length == 0) {
        if (_DEBUG)
          console.info('calculNotes - moyenne = Pas d\'ETUDIANT\' !!');
      } else if (
        qcmSelectionne.multi_nbpage == 0 &&
        qcmSelectionne.listeCopie.length == 0) {
        if (_DEBUG) console.info('calculNotes - moyenne = Pas de copie !!');
      } else {  // if (qcmSelectionne.multi_nbpage>0){ // multi : uniquement les
        // étudiants

        for (i = 0; i < qcmSelectionne.listeEtudiant.length; i++) {
          // la solution change, MAIS pas la réponse de l'étudiant !!!
          // calcul de la sommeAvant
          // calcul de la sommeApres
          // calcul de la sommeNote, et de la moyenne

          if (qcmSelectionne.listeEtudiant[i].nbcopie >= 1) {
            sommeE = 0.0;

            // combien 'rapportait' l'ancienne reponse
            re = qcmSelectionne.listeEtudiant[i].reponse[caseM];
            so = cAvant;
            sommeE = calculPointQuestion(caseM, cAvant, re, qcmSelectionne);

            // combien 'rapporte' la nouvelle reponse
            so = c;
            sommeE += calculPointQuestion(caseM, cAvant, re, qcmSelectionne);

            qcmSelectionne.listeEtudiant[i].sommenote =
              qcmSelectionne.listeEtudiant[i].sommenote + sommeE;
            qcmSelectionne.listeEtudiant[i].moyenne =
              qcmSelectionne.listeEtudiant[i].sommenote /
              qcmSelectionne.justeTotal * 20;

            qcmSelectionne.sommeTotal += sommeE;
          }
        }
      } /*else{  //simple
       qcmSelectionne.nbTotal=0
       for (i=0;  i<qcmSelectionne.listeCopie.length; i++){
         re=qcmSelectionne.listeCopie[i].reponse[caseM]
         so=cAvant
         sommeE=calculPointQuestion(caseM, cAvant, re, qcmSelectionne )

         // combien 'rapporte' la nouvelle reponse
         so=c
         sommeE+=calculPointQuestion(caseM, cAvant, re, qcmSelectionne )

         qcmSelectionne.sommeTotal+=sommeE
         trouve=0
         for (k=0;  k<qcmSelectionne.listeEtudiant.length && !trouve; k++){
           if
     (qcmSelectionne.listeEtudiant[k].idetudiant==qcmSelectionne.listeCopie[i].idetudiant){
             qcmSelectionne.listeEtudiant[i].sommenote += sommeE
             qcmSelectionne.listeEtudiant[k].moyenne=qcmSelectionne.listeEtudiant[i].sommenote/qcmSelectionne.justeTotal*20
             trouve=1
           }
         }


       }//for
     }//else
     */
      if (qcmSelectionne.nbTotal > 0 && qcmSelectionne.justeTotal > 0) {
        var res = qcmSelectionne.sommeTotal / qcmSelectionne.nbTotal * 20 /
          qcmSelectionne.justeTotal;
        if (_DEBUG) console.info('calculNotes - moyenne générale = ' + res);
      }


      // return qcmSelectionne
      deferred.resolve(qcmSelectionne);

    } catch (e) {
      deferred.reject(e);
    }  // try-catch
    return deferred.promise;

  };  // fin de this.calculNotesModifSolution



  /*******************************************************************************************************/



  this.calculNotesChangementBareme = function (
    qcmSelectionne, indice, lettre, oldV,
    newV) {  // calcule de sommenote et moyenne -> par copie et au
    // global !
    if (_DEBUG) console.info('A1')
    // 2. on calcule les notes
    var deferred = $q.defer();
    // alert("c="+c+", cAvant="+cAvant+", caseM="+caseM)
    try {
      var so = qcmSelectionne.qcmSolution[indice];

      // if (qcmSelectionne.multi_nbpage>0){ // multi : uniquement les étudiants

      for (i = 0; i < qcmSelectionne.listeEtudiant.length; i++) {
        // la solution change, MAIS pas la réponse de l'étudiant !!!
        // calcul de la sommeAvant
        // calcul de la sommeApres
        // calcul de la sommeNote, et de la moyenne

        // savoir si l'étudiant a une copie ?
        if (qcmSelectionne.listeEtudiant[i].nbcopie >= 1) {
          if (_DEBUG) console.info('B1');

          sommeE = 0.0;

          re = qcmSelectionne.listeEtudiant[i].reponse[indice];
          if (re == '(') {  // reponse vide
            if (lettre == 'v') sommeE = newV - oldV;
          } else if (re == so) {  // reponse juste
            if (lettre == 'j') sommeE = newV - oldV;
          } else {  // reponse fausse
            if (lettre == 'f') sommeE = newV - oldV;
          }
          if (_DEBUG) console.info('C1' + i);
          qcmSelectionne.listeEtudiant[i].sommenote =
            qcmSelectionne.listeEtudiant[i].sommenote + sommeE;
          qcmSelectionne.listeEtudiant[i].moyenne =
            qcmSelectionne.listeEtudiant[i].sommenote /
            qcmSelectionne.justeTotal * 20;

          for (ind = 0;
            ind < qcmSelectionne.listeEtudiant[i].tabIndiceCopie.length;
            ind++) {
            indiceC = qcmSelectionne.listeEtudiant[i].tabIndiceCopie[ind];
            if (indiceC > 0)
              qcmSelectionne.listeCopie[indiceC].sommepoints =
                qcmSelectionne.listeEtudiant[i].sommenote;
          }

          qcmSelectionne.sommeTotal += sommeE;
        }
      }
      if (_DEBUG) console.info('D1');

      /*
                if (isNaN(qcmSelectionne.sommeTotal)){
                  i=qcmSelectionne.listeEtudiant.length // quitter la boucle
                }
      */
      /*
       }else{  // simple : listeCopie
         for (i=0;  i<qcmSelectionne.listeCopie.length; i++){
           // la solution change, MAIS pas la réponse de l'étudiant !!!
           //calcul de la sommeAvant
           //calcul de la sommeApres
           //calcul de la sommeNote, et de la moyenne

           // savoir si l'étudiant a une copie ?

           sommeE=0.0

           re=qcmSelectionne.listeCopie[i].resultat[indice]
           if (re=="("){ // reponse vide
             if (lettre=='v') sommeE=newV-oldV
           }else if(re==so){ // reponse juste
             if (lettre=='j') sommeE=newV-oldV
           }else{ // reponse fausse
             if (lettre=='f') sommeE=newV-oldV
           }

           qcmSelectionne.listeCopie[i].sommepoints =
       qcmSelectionne.listeCopie[i].sommepoints + sommeE
           qcmSelectionne.listeCopie[i].moyenne =
       qcmSelectionne.listeCopie[i].sommepoints/qcmSelectionne.justeTotal*20

           qcmSelectionne.sommeTotal+=sommeE

         }
       }*/
      // return qcmSelectionne
      deferred.resolve(qcmSelectionne);

    } catch (e) {
      deferred.reject(e);
    }  // try-catch
    return deferred.promise;


  };  // fin de this.calculNotes



  /*******************************************************************************************************/


  /*******************************************************************************************************/
});  // fin service ServiceQcm



app.service('listeQCM', function ($rootScope, services, $q) {
  // structure de listeQCM
  /*
  listeQCM2 = [
  {"id":1240,"date":"2016-10-07T19:37:00.000Z","page":1,"nbReponse":5,"UneSeuleReponse":1,"nbQuestion":4,"nbEtudiant":0,
  "libelle":"","Matiere":"gte3","Nbcopies":0,"ptJuste":1,"ptFaux":0,"qcmSolution":"))))","nbQ":72,"multi_nbpage":11},
  {"id":1239,"date":"2016-10-07T18:23:00.000Z","page":1,"nbReponse":5,"UneSeuleReponse":1,"nbQuestion":4,"nbEtudiant":0,
  "libelle":"","Matiere":"gte2","Nbcopies":0,"ptJuste":1,"ptFaux":0,"qcmSolution":"((*)","nbQ":72,"multi_nbpage":10},
  {"id":1238,"date":"2016-10-07T06:06:00.000Z","page":1,"nbReponse":5,"UneSeuleReponse":1,"nbQuestion":4,"nbEtudiant":0,
  "libelle":"","Matiere":"GTE","Nbcopies":0,"ptJuste":1,"ptFaux":0,"qcmSolution":"(()*","nbQ":72,"multi_nbpage":10},
  {"id":1237,"date":"2016-10-07T05:11:00.000Z","page":1,"nbReponse":5,"UneSeuleReponse":1,"nbQuestion":10,"nbEtudiant":0,
  "libelle":"","Matiere":"gte2","Nbcopies":0,"ptJuste":1,"ptFaux":0,"qcmSolution":"((((((((((","nbQ":30,"multi_nbpage":3},
  {"id":1236,"date":"2016-10-07T05:08:00.000Z","page":1,"nbReponse":5,"UneSeuleReponse":1,"nbQuestion":10,"nbEtudiant":0,
  "libelle":"","Matiere":"gte","Nbcopies":0,"ptJuste":1,"ptFaux":0,"qcmSolution":"((((((((((","nbQ":18,"multi_nbpage":2},
  {"id":1235,"date":"2016-10-07T04:22:00.000Z","page":1,"nbReponse":5,"UneSeuleReponse":1,"nbQuestion":10,"nbEtudiant":0,
  "libelle":"","Matiere":"","Nbcopies":0,"ptJuste":1,"ptFaux":-0.4,"qcmSolution":"((((((((((","nbQ":71,"multi_nbpage":16},
  */



  /*
          k=0
          for(var i= 0, lg=listeQCM.length; i < lg; i++){
              //alert('$scope.listeQCM[i].page='+$scope.listeQCM[i].page)

              if (listeQCM[i].page<=1){
                  listeQCM2.push(listeQCM[i]);
                  listeQCM2[k].nbQ = listeQCM[i].nbQuestion
                  listeQCM2[k].multi_nbpage = listeQCM[i].page
                  k++
              }else{
                  listeQCM2[k-1].nbQ += listeQCM[i].nbQuestion
                  listeQCM2[k-1].multi_nbpage = listeQCM[i].page
              }
          }
                      */

  /*******************************************/

  this.chargeListeQCM = function () {  // charge la liste des QCM :  page 0
    // (simple) et 1 (multiple)
    var deferred = $q.defer();
    var listeQCM2 = [];

    try {
      services.qcm().then(function (data) {
        listeQCM2 = data.data;

        var d;
        var lg = listeQCM2.length;
        for (var i = 0; i < lg; i++) {
          d = listeQCM2[i].date;
          // if (i<4) alert("date="+d+ " -> "+d.substring(0,4)+ " -> "+
          // d.substring(5,7)+ " -> "+ d.substring(8,10)+ " -> "+
          // d.substring(11,13)+ " -> "+ d.substring(14,16))
          listeQCM2[i].date = new Date(
            d.substring(0, 4), d.substring(5, 7) - 1, d.substring(8, 10),
            d.substring(11, 13), d.substring(14, 16));
          listeQCM2[i].multi_nbpage = listeQCM2[i].page;
        }

        deferred.resolve(listeQCM2);
      });  // listeCopie
    } catch (e) {
      deferred.reject(e);
    }  // try-catch
    return deferred.promise;
  };

  /*******************************************/
  /*  this.chargeListeQCMlive=function(user){ // charge la liste des QCM :
  page 0 (simple) et 1 (multiple) var deferred = $q.defer(); var listeQCM2 =
  []


    try{
      //alert("user="+user)
      services.qcmlive(user).then(function(data){
          listeQCM2 = data.data;

          var d
          lg=listeQCM2.length
          for(var i= 0; i < lg; i++)
          {
              d = listeQCM2[i].date;
              //if (i<4) alert("date="+d+ " -> "+d.substring(0,4)+ " -> "+
  d.substring(5,7)+ " -> "+ d.substring(8,10)+ " -> "+ d.substring(11,13)+ "
  -> "+ d.substring(14,16)) listeQCM2[i].date = new Date(d.substring(0,4),
  d.substring(5,7)-1, d.substring(8,10), d.substring(11,13),
  d.substring(14,16) ); listeQCM2[i].multi_nbpage = listeQCM2[i].page

          }

          deferred.resolve( listeQCM2);

      });// listeCopie
    }catch(e){
      deferred.reject(e);
    }//try-catch
    return deferred.promise
  }
  */
  /*******************************************/
  this.supprimeQCM = function (
    listeQCM, idqcm) {  // supprime(listeQCM, $scope.qcmModifie.id)
    services.effaceQCM(idqcm)
      .then(function (data) {
        // effaceQCM = data.data;
      })
      .catch(function (response) {
        // services.qcm(user.id);
      })
      .finally(function (data) {
        // on pourrait simplement enlever une ligne du tableau !!
      })
  };

  /*******************************************/
  this.ajouterQCM = function (nouveauQcm, p2, p3) {
    services.ajouterQCMmultipage(nouveauQcm, p2, p3)
      .then(function (data) {
        // ajouterQCM = data.data;
      })
      .catch(function (response) {
        // services.qcm(user.id);
      })
      .finally(function (data) {
        // on pourrait simplement ajouter une ligne au tableau !!
      })
  };
  /*******************************************/
  this.ajouterQCMlive = function (nouveauQcm) {
    services.ajouterQCMlive(nouveauQcm)
      .then(function (data) {
        // ajouterQCM = data.data;
      })
      .catch(function (response) {
        // services.qcm(user.id);
      })
      .finally(function (data) {
        // on pourrait simplement ajouter une ligne au tableau !!
      })
  };
  /*******************************************/

  return 1;
});  // fin service ListeQCM
